import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import { AuthProvider } from './contexts/AuthContext';
import CookieBanner from './components/feature/CookieBanner';

/**
 * Root component of the application.
 * Uses __BASE_PATH__ injected by Vite define.
 */
function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AuthProvider>
        <AppRoutes />
        <CookieBanner />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
